import fetch from "isomorphic-fetch";
import {newNotification} from "./notifications";
import { /*API_URL,*/ API2_URL, ENTITIES_FAIL, ENTITIES_EDIT, ENTITIES_SHOW, ENTITIES_FETCH, ENTITIES_REQUEST } from "../store/config";
import { history } from "../store/store";
import _ from "lodash";
import {sessionService} from "redux-react-session";

export const entitiesShow= (page=1, filters={}) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				let params = '';
				_.mapKeys(filters, (value, key) => {
					if(value){
						params = `${params}&${key}=${value}`;
					}
				});

				dispatch(entitiesRequest());
				return fetch(`${API2_URL}/states?page=${page}${params}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(entitiesData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(entitiesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const entitiesList = () => (dispatch) => {
	dispatch(entitiesRequest());
	/*
	* Guarda las entidades en la sesion, para no mandarla a pedir al servidor, cada vez que se necesite.
	* */
    let storage = sessionStorage.getItem('etrans_entities');
    if (storage === null){
	    return dispatch(sessionService.loadUser)
		    .then(sess=> {
			    const options = {
				    headers: {
					    'Accept': 'application/json',
					    'Content-Type': 'application/json',
					    'Authorization': `Bearer ${sess.profile.access_token}`
				    },
				    method: 'get'
			    };

			    return fetch(`${API2_URL}/states?per_page=40`, options)
				    .then(result => {
					    if (result.status >= 200 && result.status < 300) {
						    return result.json();
					    } else {
						    return result.json().then(Promise.reject.bind(Promise));
					    }
				    })
				    .then(
					    json => dispatch(entitiesListData(json)),
					    error => {
						    dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						    return dispatch(entitiesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					    }
				    );
		    })
	}
	else {
        storage = JSON.parse(storage);
	    return dispatch(entitiesListData({data:storage}));
    }
};

export const entityEdit = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(entitiesRequest());
				return fetch(`${API2_URL}/states/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(entityEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(entitiesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const entitySave = (values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(values)
				};

				dispatch(entitiesRequest());
				return fetch(`${API2_URL}/states${values.id ? `/${values.id}?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La entidad se ha guardado correctamente", type: "success"}));
							if(_.isEmpty(values.id)){
								history.push(`/entidades/editar/${json.data.id}`);
							}
							return dispatch(entityEditData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(entitiesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const entityDelete = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'delete'
				};

				dispatch(entitiesRequest());
				return fetch(`${API2_URL}/states/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La entidad se ha guardado correctamente", type: "success"}));
							dispatch(entitiesShow());
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(entitiesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

const entitiesRequest = () => {
	return {
		type: ENTITIES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

const entitiesFailed = (error) => {
	return {
		type: ENTITIES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};

const entitiesData = (json) => {
	return {
		type: ENTITIES_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const entitiesListData = (json) => {
    sessionStorage.setItem('etrans_entities', JSON.stringify(json.data));
	return {
		type: ENTITIES_FETCH,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
};

const entityEditData = (json) => {
	return {
		type: ENTITIES_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/entities.js